export default function useScroll () {

  const getHeaderHeight = () => {
    let height = 0
    const adminBar = document.getElementById('wpadminbar')
    height += adminBar ? adminBar.getBoundingClientRect().height : 0
    const header = document.querySelector('.dm-header')
    height += header ? header.getBoundingClientRect().height : 0
    return height
  }

  const scrollTo = (top) => {
    const offset = top + window.pageYOffset - getHeaderHeight()

    window.scrollTo({
      top: offset,
      behavior: 'smooth'
    })
  }

  return {
    getHeaderHeight,
    scrollTo
  }
}